import { BookingRecurringSuccessModalContent } from './BookingRecurringSuccessModalContent';

export const BookingRecurringSuccessModal = (): JSX.Element => (<BookingRecurringSuccessModalContent />);
